import { Fragment } from 'react'
import { Trans, useTranslation } from 'react-i18next'

type item = {
  linkText?: string,
  renderItem?: React.ReactElement
}

interface TranslateParseProps {
  text: string,
  inject?: item[]
}

/**
 * This component parse the html in translation and injects it to the translation text. The items mapped is injected using the index of the array and placeholder with links as such shall be represented by <0>{{0}}</0> as convention where 0 is the index of the injected element.
 * @param text Translation key to be mapped to the dictionary
 * @param inject  Array of links and or html elements to be injected to the translation. Note:- The injection in the translation is mapped via the array index order
 * @returns Html parsed translation
 */

const TranslateParse = (props: TranslateParseProps) => {
  const { text, inject = [] } = props
  const { t } = useTranslation()

  const linkTexts: Record<string, string> = {}
  inject.forEach((ele, i) => linkTexts[i] = t(ele?.linkText ?? ""))

  const ctx = inject.map(ele => ele.renderItem ?? <Fragment></Fragment>)

  return (
    <Trans
      t={t}
      i18nKey={text}
      values={linkTexts}
      components={ctx}
    />
  )
}

export default TranslateParse